// extracted by mini-css-extract-plugin
export default {"checklist":"checklist--27ed6159"};